import angular from "angular";

angular
    .module('app')
    .component('userCoursesList', {
        template: require('./user-courses-list.html'),
        controller: ['$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.user = $ctrl.resolve.user;
        $ctrl.getCoursesList();
    };

    $ctrl.getCoursesList = function () {
        $ctrl.loading = true;
        $http
            .get(`/admin/users/${$ctrl.user.id}/get-courses-list`)
            .then(
                function (response) {
                    $ctrl.loading = false;
                    $ctrl.courses = response.data.courses;
                },
                function (error) {
                    $ctrl.loading = false;
                }
            );
    };
}
